import { Link } from "react-router-dom";
import NewsletterSignup from "./NewsletterSignup";

export default function JoinTheVibe() {
  return (
    <section className="py-16 md:py-20 bg-sage/10" data-testid="join-the-vibe-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="bg-sunset rounded-3xl p-10 md:p-14">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <p className="font-accent text-lg text-white/60 mb-1">stay in the loop</p>
              <h2 className="font-display text-2xl sm:text-3xl text-white tracking-tight mb-2">
                News, Events & Good Vibes
              </h2>
              <p className="text-white/50 text-sm leading-relaxed">
                Be the first to hear about upcoming events, new blog posts and everything Justjjax.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 items-stretch sm:items-end">
              <div className="flex-1">
                <NewsletterSignup variant="dark" />
              </div>
              <Link
                to="/community"
                className="bg-white text-charcoal hover:bg-white/90 rounded-full px-6 py-3 text-sm font-medium transition-all duration-300 text-center whitespace-nowrap"
                data-testid="join-vibe-book-event-btn"
              >
                Book an Event
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
